import { useCallback, useState } from "react";
import { Button } from "primereact/button";
import { useSelector } from "react-redux";
import PageTitle from "../common/PageTitle";
import TabHeader from "../common/TabHeader";
import HasRequiredAuthority from "../dependencies/HasRequiredAuthority";
import { useAppContext } from "../../providers/ProviderAppContainer";
import { AUTHORITIES } from "../../constants";
import DialogAddNotification from "./DialogAddNotification";

export default function ManageNotifications() {
    const { requestAPI, showToast } = useAppContext();
    const { branches = [], notification_types: notificationTypes = [] } = useSelector(
        (state) => state.stateTemplateConfig?.global || {},
    );

    const [lastResult, setLastResult] = useState();
    const [dialogAdd, setDialogAdd] = useState({ visible: false });

    const closeAdd = useCallback(() => setDialogAdd((prev) => ({ ...prev, visible: false })), []);

    return (
        <div className="flex flex-column h-full">
            <PageTitle title="Notifications" />
            <TabHeader
                className="px-3 pt-3"
                title="Send Batch Notifications"
                highlights={lastResult ? [`Last sent to ${lastResult.notified} users`] : ["Select batches and send a notification"]}
                actionItems={[
                    <HasRequiredAuthority requiredAuthority={AUTHORITIES.CREATE_NOTIFICATION}>
                        <Button
                            icon="pi pi-plus"
                            severity="warning"
                            onClick={() => setDialogAdd({ visible: true })}
                        />
                    </HasRequiredAuthority>,
                ]}
            />

            <div className="px-3 pb-3 flex-1 overflow-y-auto">
                <p className="text-color-secondary">
                    Create a notification with title, description, urgency type, and optional attachments. It will be delivered to every
                    student in the selected batches, and each student will also receive a short email with a Check Notifications link.
                </p>
            </div>

            <DialogAddNotification
                visible={dialogAdd.visible}
                closeDialog={closeAdd}
                branches={branches}
                notificationTypes={notificationTypes}
                requestAPI={requestAPI}
                showToast={showToast}
                onSent={setLastResult}
            />
        </div>
    );
}
